<div class="min-h-screen w-full flex flex-col">
    <app-header></app-header>
    <app-toolbar></app-toolbar>
    <app-submenu [items]="subMenuItems"></app-submenu>
    <div class="min-h-screen bg-[#f6f6f6] pb-20 pt-10">
        <section
            class="bg-white border border-[#f0f0f0] rounded-[15px] mx-auto w-[95%] max-w-[1200px] p-2 shadow-[1px_1px_20px_0px_rgba(0,0,0,0.1)]">
            <div class="flex justify-center mt-4 mb-5">
                <div class="search w-full max-w-[300px]">
                    <div class="search-box flex align-middle pl-8 w-full bg-[#f0f0f0] rounded-[10px] h-10">
                        <input #filter [(ngModel)]="searcherCriteria" (input)="onSearchInput($event)"
                            class="form-control" placeholder="BUSCAR POR REFERENCIA/CLIENTE" />
                    </div>
                </div>
            </div>

            <div class="">
                <p-table #dt [value]="filteredInvoices" styleClass="p-datatable-striped" dataKey="invoice_number"
                    [paginator]="true" [rows]="10" [lazy]="true" [totalRecords]="totalRecords"
                    (onLazyLoad)="loadInvoices($event)" [loading]="loading">
                    <ng-template pTemplate="header">
                        <tr>
                            <th pSortableColumn="reference" class="text-black font-bold text-nowrap">
                                Reserva
                            </th>
                            <th pSortableColumn="total" class="text-black font-bold w-36 text-nowrap">
                                Monto <p-sortIcon field="total"></p-sortIcon>
                            </th>
                            <th pSortableColumn="customer_id" class="text-black font-bold w-36 text-nowrap">
                                Cliente <p-sortIcon field="customer_name"></p-sortIcon>
                            </th>
                            <th pSortableColumn="proforma_created_at" class="text-black font-bold w-36 text-nowrap">
                                Fecha de emisión <p-sortIcon field="proforma_created_at"></p-sortIcon>
                            </th>
                            <th class="text-black font-bold text-nowrap">Acciones</th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-invoice let-i="rowIndex" let-expanded="expanded">
                        <tr appButtonsHoverTable>
                            <td>
                                <span class="text-black font-bold whitespace-nowrap">
                                    {{ invoice.booking?.reference }}
                                </span>
                            </td>
                            <td>{{ invoice.total | currency : "EUR" }}</td>
                            <td class="text-center">
                                {{ invoice.customer_name }}
                            </td>
                            <td>{{ invoice.proforma_created_at | date:'dd/MM/yyyy - hh:mm a' }}</td>
                            <td>
                                <div class="hide-buttons max-w-[900px]">

                                    <button pButton type="button"
                                        class="bg-blue-600 rounded-md p-1 text-white text-xs font-bold "
                                        (click)="download(invoice.id)" pTooltip="Ver Proforma" tooltipPosition="left">
                                        Ver Proforma
                                    </button>
                                </div>
                            </td>
                        </tr>
                    </ng-template>

                </p-table>
                <ng-template #noData>
                    <div *ngIf="filteredInvoices && filteredInvoices.length === 0"
                        class="mt-5 flex justify-center items-center w-full bg-slate-200 border border-dashed border-slate-500 rounded-xl hover:cursor-pointer p-40">
                        <h1 class="text-center text-2xl text-slate-500">
                            Genera una nueva factura<br />
                        </h1>
                    </div>
                </ng-template>

            </div>
        </section>
    </div>
</div>